import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nkbvwqtp9e: FaireBrandEntity = {
  token: "b_nkbvwqtp9e",
  type: "brand",
  name: "Vobelle",
  avatarUrl:
    "https://cdn.faire.com/fastly/38b8b178bc7851d5f3ea8c0aa211b646f0ec23cc7f54e3ea35d54913dd66b361.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/81b679b06634fdab08e128cf195504d8dacbc3887e48dd996a22e2e47999839a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/38b8b178bc7851d5f3ea8c0aa211b646f0ec23cc7f54e3ea35d54913dd66b361.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/81b679b06634fdab08e128cf195504d8dacbc3887e48dd996a22e2e47999839a.jpeg",
  location: "Danielson, CT, USA",
  minimumOrderDollars: 350,
  rating: 5,
  reviewCount: 2,
  isTopShop: true,
  isInsider: true,
  description:
    "Nestled in the quiet town of Killingly, CT, Vobelle is a yarn and knitwear studio where each piece is thoughtfully designed and meticulously crafted.\n\nOur process is slow and deliberate. We dye and ply 100% merino wool in small batches to create our own unique yarns. These are then handmade into knitwear that carries the time, care, and character of the craft. This isn’t just about quality – it’s about staying connected to natural fibers that feel good against the skin and are kind to the environment.\n\nOur collection is a blend of the traditional and the contemporary. From cozy, oversized knits that wrap you in comfort to striking graphic patterns that make a statement, each piece has its own story, waiting to be shared. Whether you're looking to add a touch of handmade charm to your wardrobe or searching for the perfect gift, Vobelle offers something unique, timeless, and made with love.\n\nhttps://vobelle.com\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:50.029Z",
    importedBy: "entity-db-cli",
  },
};
